import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  background: #27304E;
  align-items: center;
  border-radius: 4px;
  padding: 0 80px 0 0px;
  position: relative;
  color: white;
 `;

export const TempGraphCont = styled.div`
  height: 120px;
  display: flex;
  align-items: center;
  color: black;
  position: relative;

  & > div{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
    height: 100%;
    marginLeft: auto;
  }

`;

export const NumberLabel = styled(Typography)`
  color: white;
  font-weight: bold;
  position: absolute;
  margin: auto;
`;


export const Label = styled(Typography)`
  color: white;
  width:100%;
`;

export const Hr = styled.div`
  height: 80px;
  width: 1px;
  background-color: rgba(255,255,255,0.3);
  margin: 0 auto;
`;

export const ButtonCustom = styled(Button)`
  border-radius: 50%;
  position:absolute;
  right:0;
  bottom:20px;
  padding: 0;
  color: white;
`;

